export default __webpack_public_path__ + "static/TD_1_hour_landing_page-39cc072e5ca12d86aec8d66c2827ac1f.png";